/**
 * YOUTUBE 表示
 * @param target : Target ID
 * @param id : Youtube ID
 */
const youtubeAutoPlay = (target, id) => {
  let player

  const onYouTubeIframeAPIReady = () => {
    player = new YT.Player(target, {
      videoId: id,
      playerVars: {
        playsinline: 1,
        start: 1,
        loop: 1,
        listType: 'playlist',
        playlist: id,
        rel: 0,
        controls: 0,
      },
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
    })
  }

  //プレーヤの準備完了後に呼び出す関数
  const onPlayerReady = (event) => {
    event.target.mute() //ミュートにしないとスマホで再生されない
    event.target.playVideo() //ビデオを再生
  }

  const onPlayerStateChange = (event) => {
    let ytStatus = event.target.getPlayerState()
    if (ytStatus === YT.PlayerState.ENDED) {
      event.target.mute() //ミュートにしないとスマホで再生されない
      event.target.playVideo() //ビデオを再生
    }
    if (event.data === 1) {
      document.querySelector('.top-mv__cover').classList.add('is-hide')
    }
  }

  // const screen_fit = () => {
  //   const movieBaseWidth = document.querySelector(`#${target}`).clientWidth + 100
  //   const movieBaseHeight = document.querySelector(`#${target}`).clientHeight + 100
  //   let movieWidth = 560
  //   let movieHeight = 315
  //   const rate = Math.max(movieBaseHeight / movieHeight, movieBaseWidth / movieWidth)
  //
  //   movieWidth = movieWidth * rate
  //   movieHeight = movieHeight * rate
  //
  //   Object.assign(document.querySelector(`#${target}`).style, {
  //     width: movieWidth,
  //     height: movieHeight,
  //     top: (movieHeight - (movieBaseHeight - 100)) * -0.5,
  //     left: (movieWidth - (movieBaseWidth - 100)) * -0.5,
  //   })
  // }

  // window.addEventListener('resize', () => {
  //   // screen_fit()
  // })

  onYouTubeIframeAPIReady()
  // screen_fit()
}

export { youtubeAutoPlay }
